import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    contactInformation: {
      title: translate({ id: 'orders.edit.titles.customerContact' }),
    },
    serviceTime: {
      title: translate({ id: 'orders.edit.titles.serviceTime' }),
    },
    additionalDetails: {
      title: translate({ id: 'orders.additionalDetails.title' }),
    },
  }))

  return api
}
